import script from "./GmxCheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxCheckBox.vue?vue&type=script&setup=true&lang=js"

import "./GmxCheckBox.vue?vue&type=style&index=0&id=40d9f1ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40d9f1ae"]])

export default __exports__